import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { first } from "rxjs/operators";
import { UserService } from "src/app/user/user.service";
import { SessionService } from "../../shared/services/session.service";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(
    private sessionService: SessionService,
    private userService: UserService,
    private router: Router
  ) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.checkLogin(state.url);
  }

  checkLogin(url: string): boolean | UrlTree {
    if (this.sessionService.isLoggedIn()) {
      if (!this.sessionService.account) {
        this.userService.account().pipe(first()).subscribe();
      }
      return true;
    }

    // Store the attempted URL for redirecting
    this.sessionService.redirectUrl = url;

    return this.router.createUrlTree(["/login"]);
  }
}
